export default "__VITE_ASSET__Dfgjqq4j__"